module.exports = __webpack_public_path__ + "static/media/vvns-order-tracking-phone-icon.523f4b0a.svg";